import { render, staticRenderFns } from "./ProjectReportEditor.vue?vue&type=template&id=3814376b&"
import script from "./ProjectReportEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectReportEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports